import type { FieldMeta } from '@crm/shared'
import { TextField } from './TextField'
import { LongTextField } from './LongTextField'
import { NumberField } from './NumberField'
import { BooleanField } from './BooleanField'
import { EnumField } from './EnumField'
import { SelectField } from './SelectField'
import { MultiSelectField } from './MultiSelectField'
import { DateField } from './DateField'
import { DateTimeField } from './DateTimeField'
import { LookupField } from './LookupField'
import { MultiLookupField } from './MultiLookupField'
import { IndicatorField } from './IndicatorField'
import { ReverseLookupField } from './ReverseLookupField'
import { JsonField } from './JsonField'

export interface FieldRendererProps {
  field: FieldMeta
  value: unknown
  mode: 'view' | 'edit'
  onChange?: (value: unknown) => void
  error?: string
  disabled?: boolean
  tenantId?: string
  hideLabel?: boolean
  dynamicOptions?: Array<{ value: string; label: string }>
}

export function FieldRenderer({ field, value, mode, onChange, error, disabled, tenantId, hideLabel, dynamicOptions }: FieldRendererProps) {
  const props = { field, value, mode, onChange, error, disabled, tenantId, hideLabel, dynamicOptions }

  switch (field.type) {
    case 'text':
      return <TextField {...props} />
    case 'long_text':
      return <LongTextField {...props} />
    case 'number':
      return <NumberField {...props} />
    case 'boolean':
      return <BooleanField {...props} />
    case 'enum':
      return <EnumField {...props} />
    case 'select':
      return <SelectField {...props} />
    case 'multi_select':
      return <MultiSelectField {...props} />
    case 'date':
      return <DateField {...props} />
    case 'datetime':
      return <DateTimeField {...props} />
    case 'lookup':
      return <LookupField {...props} />
    case 'multi_lookup':
      return <MultiLookupField {...props} />
    case 'indicator':
      return <IndicatorField {...props} />
    case 'reverse_lookup':
      return <ReverseLookupField {...props} />
    case 'json':
      return <JsonField {...props} />
    default:
      return mode === 'view' ? <span>{String(value ?? '')}</span> : (
        <TextField {...props} />
      )
  }
}
